import { render } from "./InputUploadOnlyFile.vue?vue&type=template&id=38c192d1"
import script from "./InputUploadOnlyFile.vue?vue&type=script&lang=js"
export * from "./InputUploadOnlyFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__